// extracted by mini-css-extract-plugin
export default {"root":"styles_root__sNCgv","root_item":"styles_root_item__tSA+G"};